import deobfuscateString from '@domain-group/fe-allhomes-library/lib/utils/deobfuscate-string';
export default ((_ref, updateContext, getContext) => {
  var absoluteUrlBase = _ref.absoluteUrlBase;
  var baseUrl = deobfuscateString(absoluteUrlBase || '').replace(/\/$/, '');
  var getAbsoluteUrl = inputUrl => {
    var url = deobfuscateString(inputUrl || '');
    if (url.startsWith('http') || url.startsWith('//')) {
      return url;
    }
    return "".concat(baseUrl).concat(url.startsWith('/') ? url : "/".concat(url));
  };
  var setRequestedValues = function setRequestedValues() {
    var currentValues = getContext().requestedValues;
    for (var _len = arguments.length, requestedValues = new Array(_len), _key = 0; _key < _len; _key++) {
      requestedValues[_key] = arguments[_key];
    }
    var newValues = new Set([...currentValues, ...requestedValues]);
    if (newValues.size > currentValues.size) {
      updateContext({
        requestedValues: newValues
      });
    }
  };
  return {
    getAbsoluteUrl,
    setRequestedValues,
    requestedValues: new Set()
  };
});